module.exports = __webpack_public_path__ + "media/images/img-adventurer-12318503fbcf2c0324bd45aa4f2867bf.svg";